import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../../../jss_setup";
import { useSelector } from "react-redux";
import { getTermsAndConditionsSelector } from "../../../../selectors";

const styles = createUseStyles({
  CustomCheckbox: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    justifyContent: "space-between",
    gridGap: "2rem",
    alignItems: "center",
    width: "100%",
    ..._.get(props, "customStyles.CustomCheckbox", {}),
  }),
  checkboxLabel: (props) => ({
    fontSize: "inherit",
    fontWeight: 500,
    ..._.get(props, "customStyles.checkboxLabel", {}),
  }),
  customCheckbox: {
    position: "relative",
    cursor: "pointer",
    userSelect: "none",
  },
  input: {
    position: "absolute",
    opacity: "0",
    cursor: "pointer",
  },
  checkmark: {
    position: "absolute",
    top: "-10px",
    height: "20px",
    width: "20px",
    backgroundColor: "#eee",
    border: `2px solid ${jssVariables.colors.base_color}`,
    borderRadius: "4px",
  },
  checkedCheckmark: {
    backgroundColor: jssVariables.colors.base_color,
    border: `2px solid ${jssVariables.colors.base_color}`,
  },
  checkmarkAfter: {
    "&:after": {
      content: '""',
      position: "absolute",
      display: "none",
    },
  },
  checkedCheckmarkAfter: {
    "&:after": {
      display: "block",
      content: '""',
      position: "absolute",
      left: "6px",
      top: "2px",
      width: "5px",
      height: "10px",
      border: "solid",
      borderWidth: "0 2px 2px 0",
      borderColor: "white",
      transform: "rotate(45deg)",
    },
  },
});
export const CustomCheckbox = ({ label, checked, setChecked, id }) => {
  const classes = styles();

  const termsAndConditions = useSelector((state) =>
    getTermsAndConditionsSelector(state)
  );
  return (
    <div className={classes.CustomCheckbox} id={id}>
      <label className={classes.customCheckbox}>
        <input
          id="termsAndConditionsCheckBox"
          type="checkbox"
          className={classes.input}
          onChange={() => setChecked(!checked)}
        />
        <span
          className={`${classes.checkmark} ${
            checked ? classes.checkedCheckmark : ""
          }`}>
          <span
            className={`${classes.checkmarkAfter} ${
              checked ? classes.checkedCheckmarkAfter : ""
            }`}></span>
        </span>
      </label>
      <label className={classes.checkboxLabel}>
        {label}
        {termsAndConditions.length > 0 && " and the "}
        {termsAndConditions.length > 0 && (
          <a
            target="_blank"
            rel="noreferrer"
            href={`${window.location.origin}/terms-and-conditions/`}>
            General Terms & Conditions
          </a>
        )}
      </label>
    </div>
  );
};
CustomCheckbox.defaultProps = {
  id: "",
};
CustomCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
  id: PropTypes.string,
};
